import React from 'react';

const ProductItem = ({ product, isSelected, onSelect }) => {
  const handleClick = () => onSelect(product.non_gp_product_id.toString(), product);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={`aptv2-product-item${isSelected ? ' aptv2-product-item--selected' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="radio"
      aria-checked={isSelected}
      aria-describedby={`aptv2-desc-${product.non_gp_product_id}`}
    >
      {/* Radio indicator */}
      <div className={`aptv2-radio${isSelected ? ' aptv2-radio--checked' : ''}`} aria-hidden="true">
        {isSelected && <div className="aptv2-radio-dot" />}
      </div>

      {/* Content */}
      <div className="aptv2-product-content">
        <span className="aptv2-product-name">{product.name}</span>
        {product.description && !product.product_specific_booking_page_long_copy && !product.product_specific_booking_page_short_copy && (
          <span
            className="aptv2-product-desc"
            id={`aptv2-desc-${product.non_gp_product_id}`}
          >
            {product.description}
          </span>
        )}
        {product.product_specific_booking_page_long_copy && (
          <span
            className="aptv2-product-desc aptv2-product-desc-desktop"
            dangerouslySetInnerHTML={{ __html: product.product_specific_booking_page_long_copy }}
          />
        )}
        {product.product_specific_booking_page_short_copy && (
          <span
            className="aptv2-product-desc aptv2-product-desc-mobile"
            dangerouslySetInnerHTML={{ __html: product.product_specific_booking_page_short_copy }}
          />
        )}
      </div>

    </div>
  );
};

export default ProductItem;
